import BlogName from './BlogName';

export default function GeneratedBlogNames({ setNameOpen }) {
  const blogNames = [
    'GlobetrotterJoy',
    'TrekTrailTales',
    'WayfarerWinks',
    'ItchyFeetFun',
    'GlobeGiggles',
    'MapMischief',
    'RoamRainbows',
    'TrekkerJoy',
    'SnapSafaris',
    'PennyPinchTour',
    'NomadThrifty',
    'ExploreEcho',
    'TrailTriumph',
    'FoodieWander',
    'TrekkerTrove',
    'TrailTripper',
    'SnapRoam',
    'PicRoutes',
    'GlobeGlimpse',
    'RouteVibes',
    'WayfarerWow',
    'JetsetJots',
    'Wandering Wombats',
    'Nomadic Ninjas',
  ];
  return (
    <>
      <section className="tw-py-20 tw-bg-white lg:tw-py-24">
        <div className="tw-px-4 tw-mx-auto tw-max-w-7xl sm:tw-px-6 lg:tw-px-8">
          <div className="tw-max-w-2xl tw-mx-auto tw-text-center">
            <h2 className="tw-text-3xl tw-font-bold tw-leading-tight tw-text-gray-900 sm:tw-text-4xl lg:tw-text-5xl">
              Example Travel Blog Name Ideas to Get You Started
            </h2>
            <p className="tw-max-w-lg tw-mx-auto tw-mt-4 tw-text-base tw-leading-relaxed tw-text-gray-600">
              A few starting points in different styles. Click any name to check
              whether the .com domain and the TravelFeed username are still
              free.
            </p>
          </div>
          <div className="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 tw-gap-2 sm:tw-gap-4 tw-pt-8">
            {blogNames.map(blogName => (
              <BlogName
                key={blogName}
                name={blogName}
                setNameOpen={setNameOpen}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
